import { render, staticRenderFns } from "./InvoiceSummary.vue?vue&type=template&id=10ffed98&"
import script from "./InvoiceSummary.vue?vue&type=script&lang=js&"
export * from "./InvoiceSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports